var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ inertia: _vm.inertia, moving: _vm.moving, frozen: _vm.frozen },attrs:{"scroll-holder":""}},[_c('div',{attrs:{"scroll-pseudo-body":""}}),_c('div',{class:_vm.containerClass,attrs:{"scroll-container":""}},[_c('div',{class:_vm.bodyClass,attrs:{"scroll-body":""}},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }